import type { FC } from 'react';

import Button from '../Button';
import ContactFormSheet from '../Landing/ContactFormSheet';
import Text from '../Text';

const ContactCta: FC = () => {
  return (
    <div className="flex w-full flex-col gap-3 rounded-2xl bg-jb-neutral-100 p-5 shadow-big-moduls">
      <Text variant="jb-h5" className="font-semibold">
        Talk to us about your setup
      </Text>
      <Text variant="jb-body-small" className="text-jb-neutral-800">
        Tell us where the manual work piles up. We map the process, the
        automation fit and the likely impact before anyone talks pricing.
      </Text>
      <ContactFormSheet
        sheetTriggerProps={{ asChild: true }}
        modalParam="contact"
      >
        <Button
          variant="jbPrimary"
          size="sm"
          className="w-full"
          suffixIcon="material-symbols-light:arrow-forward"
        >
          Contact us
        </Button>
      </ContactFormSheet>
    </div>
  );
};

export default ContactCta;
